// Shared controls use the same locale as the statically rendered page.
window.regalaText = (key, values = {}) => {
  const text = window.REGALA_MARKET.messages[key];
  if (typeof text !== 'string') throw new Error(`Missing translation: ${key}`);
  return text.replace(/\{(\w+)\}/g, (match, name) => String(values[name] ?? match));
};
